<!--
 * @Author: your name
 * @Date: 2020-07-07 13:52:06
 * @LastEditTime: 2022-08-17 16:27:02
 * @LastEditors: 小陈
 * @Description: In User Settings Edit
 * @FilePath: \1-trunk\src\views\mdt-consult\manage\addNewDepartment.vue
-->
<template>
  <div class="addNewZs">
    <van-nav-bar title="新建诊室"
                 left-arrow
                 @click-left="$router.go(-1)">
      <template #left></template>
      <template #right></template>
    </van-nav-bar>

    <div class="addData">
      <forms :data="zhenShiData"
             @getFormPicker="getFormPicker"></forms>
    </div>

    <div class="save"
         @click="save">保存</div>

    <!-- 选择专家 -->
    <div class="pickExpert"
         v-if="expertShow">
      <div class="pickHead">
        <span class="cancel"
              @clicl="cancelExpert">取消</span>
        <span class="title">会诊专家</span>
        <span class="confirm"
              @click="confirmExpert">确定</span>
      </div>
      <ul class="expertBody">
        <li v-for="(item, key) in expertData"
            :key="key"
            @click="item.choose = !item.choose">
          <span class="expertName">{{ item.name }}</span>
          <i class="choose"
             v-if="item.choose">√</i>
        </li>
      </ul>
    </div>

    <!-- 时间选择器 -->
    <van-datetime-picker v-if="timeShow"
                         v-model="currentDate"
                         type="datetime"
                         :title="pickerTitle"
                         :min-date="minDate"
                         :max-date="maxDate"
                         :filter="filter"
                         @confirm="timeConfirm"
                         @cancel="timeCancel" />

    <!-- 选择器 -->
    <van-picker v-model="showPicker"
                v-if="showPicker"
                show-toolbar
                :title="pickerTitle"
                :columns="columns"
                @confirm="onConfirm"
                @cancel="onCancel"
                @change="onChange" />
  </div>
</template>
<script>
import forms from '../../../components/basics/form';
export default {
  data () {
    return {
      showPicker: false,
      columns: [],
      pickerTitle: '',
      zhenShiData: [
        {
          label: '会诊名称',
          value: '',
          field: true
        },
        {
          label: '会诊开始时间',
          value: '',
          picker: 'startTime'
        },
        {
          label: '会诊结束时间',
          value: '',
          picker: 'endTime'
        },
        {
          label: '会议地点',
          value: '',
          picker: 'local'
        },
        {
          label: '会诊专家',
          value: '',
          picker: 'expert'
        },
        {
          label: '讨论会主席',
          value: '',
          picker: 'chairman'
        },
        {
          label: '记录员',
          value: '',
          picker: 'recorder'
        }
      ],
      expertData: [],
      expertShow: false,
      timeShow: false,
      minDate: new Date(),
      maxDate: new Date(),
      currentDate: new Date(),
      startTime: new Date(),
      meetingRoomColumns: [],
      userCharmanList: [],
      userRecordList: [],
      saveData: {
        businessId: 0,
        caseId: 0,
        conferenceEndTime: 'string',
        conferenceId: 0,
        conferenceStartTime: 'string',
        consultHostId: 0,
        consultName: 'string',
        expertList: [0],
        plateformId: 0,
        recorderId: 0
      }
    };
  },
  created () {
    this.saveData.businessId = Number(this.$route.query.businessId)
    this.saveData.caseId = Number(this.$route.query.caseid)
    this.saveData.plateformId = Number(this.$store.state.userInfo.platformId)
  },
  mounted () { },
  methods: {
    getFormPicker (e) {
      this.showPicker = false;
      this.expertShow = false;
      this.timeShow = false;
      this.returnData = e;
      if (e === 'startTime') {
        this.pickerTitle = '会诊开始时间';
        var dd = new Date();
        this.minDate = dd;
        this.maxDate = new Date(
          dd.getFullYear(),
          dd.getMonth(),
          dd.getDate() + 2
        );
        this.timeShow = true;
      } else if (e === 'endTime') {
        if (this.zhenShiData[1].value === '') {
          this.$toast('请先选择开始时间');
        } else {
          this.pickerTitle = '会诊结束时间';
          var d2 = new Date();
          var year = this.startTime.getFullYear();
          var month = this.startTime.getMonth();
          var day = this.startTime.getDate();
          var hour = this.startTime.getHours();
          var mins = this.startTime.getMinutes();
          if (this.startTime.getMinutes() >= 45) {
            this.minDate = new Date(year, month, day, hour + 1);
          } else {
            this.minDate = new Date(year, month, day, hour, mins + 15);
          }
          // this.minDate = new Date(this.startTime.getFullYear(), this.startTime.getMonth(), this.startTime.getDate(), this.startTime.getHours(), this.startTime.getMinutes() + 15)
          this.maxDate = new Date(
            d2.getFullYear(),
            d2.getMonth(),
            d2.getDate() + 2,
            23,
            45
          );
          this.timeShow = true;
        }
      } else if (e === 'local') {
        this.pickerTitle = '会议地址';
        // 调用获取会议地址接口
        this.getMeetingRoom();
        this.columns = this.meetingRoomColumns;
        this.showPicker = true;
      } else if (e === 'expert') {
        this.getUserList();
        this.expertShow = true;
      } else if (e === 'chairman') {
        this.pickerTitle = '讨论会主席';
        // 调用主席名单接口
        this.gethostlist();
        this.showPicker = true;
      } else if (e === 'recorder') {
        this.pickerTitle = '记录员';
        // 调用记录员名单接口
        this.getrecordlist();
        this.showPicker = true;
      }
    },
    onConfirm (value, index) {
      if (this.returnData === 'local') {
        this.zhenShiData[3].value = value.address;
        this.saveData.conferenceAddress = value.address
        this.saveData.conferenceId = value.id
      } else if (this.returnData === 'chairman') {
        this.zhenShiData[5].value = value.text;
        this.saveData.consultHostId = value.id
      } else if (this.returnData === 'recorder') {
        this.zhenShiData[6].value = value.text;
        this.saveData.recorderId = value.id
      }

      this.showPicker = false;
    },
    onChange (picker, value, index) { },
    onCancel () {
      // alert('取消')
      this.showPicker = false;
    },
    cancelExpert () {
      this.expertShow = false;
    },
    confirmExpert () {
      var checkedArr = [];
      for (var i = 0; i < this.expertData.length; i++) {
        if (this.expertData[i].choose) {
          checkedArr.push(this.expertData[i].name);
        }
      }
      this.zhenShiData[4].value = checkedArr.join(',');
      this.expertShow = false;
    },
    filter (type, options) {
      if (type === 'minute') {
        return options.filter((option) => option % 15 === 0);
      }
      return options;
    },
    timeConfirm (value) {
      var d = new Date(value);
      var year = d.getFullYear();
      var month = d.getMonth() + 1;
      var day = d.getDate();
      var hour = d.getHours();
      if (hour === 0) {
        hour = '00';
      }
      var mins = d.getMinutes();
      if (mins === 0) {
        mins = '00';
      }
      var datetime = year + '-' + month + '-' + day + ' ' + hour + ':' + mins;
      if (this.returnData === 'startTime') {
        this.zhenShiData[1].value = datetime;
        this.startTime = d;
        this.saveData.conferenceStartTime = datetime
      } else if (this.returnData === 'endTime') {
        this.zhenShiData[2].value = datetime;
        this.saveData.conferenceEndTime = datetime
      }
      this.timeShow = false;
    },
    timeCancel () {
      this.timeShow = false;
    },
    // 获取会议室
    getMeetingRoom () {
      this.$axios
        .post('admin/conference/page/list', {
          version: this.$version,
          data: { current: 1, size: 999 }
        })
        .then((res) => {
          if (res.status) {
            res.data.list.forEach((item) => {
              this.meetingRoomColumns.push({
                text: item.name + '(' + item.address + ')',
                address: item.address,
                id: item.id
              });
            });
          }
        });
    },
    // 获取讨论专家列表
    getUserList () {
      this.$axios
        .post('admin/user/list', {
          data: {
            current: 1,
            location: 0,
            platformId: this.$store.state.userInfo.platformId,
            roleId: 3,
            size: 100
          },
          version: 0
        })
        .then((res) => {
          res.data.list.forEach((item) => {
            this.expertData.push({
              name: item.trueName,
              id: item.id,
              choose: false
            });
          });
          // var that = this
          // this.tableData = res.data.list
        });
    },
    // 获取讨论主席
    gethostlist () {
      this.$axios
        .post('admin/user/list', {
          data: {
            current: 1,
            location: 0,
            platformId: this.$store.state.userInfo.platformId,
            roleId: 5,
            size: 100
          },
          version: 0
        })
        .then((res) => {
          var that = this;
          res.data.list.map(function (item, index) {
            that.userCharmanList.push({
              text: item.trueName + '(' + item.departmentName + ')',
              id: item.id
            });
          });
          that.columns = that.userCharmanList;
        });
    },
    // 获取记录员
    getrecordlist () {
      this.$axios
        .post('admin/user/list', {
          data: {
            current: 1,
            location: 0,
            platformId: this.$store.state.userInfo.platformId,
            roleId: 4,
            size: 100
          },
          version: 0
        })
        .then((res) => {
          var that = this;
          res.data.list.map(function (item, index) {
            that.userRecordList.push({
              text: item.trueName + '(' + item.departmentName + ')',
              id: item.id
            });
          });
          that.columns = that.userRecordList;
        });
    },
    // 保存
    save () {
      // 置空讨论专家列表
      this.saveData.expertList = []
      this.saveData.consultName = this.zhenShiData[0].value
      this.expertData.forEach(item => {
        if (item.choose) {
          this.saveData.expertList.push(item.id)
        }
      })

      this.$axios.post('api/consult/detail/urgent/consultcard/save', {
        version: this.$version,
        data: this.saveData
      }).then(res => {
        if (res.status) {
          this.$router.go(-2)
        }
      })
    }
  },
  watch: {},
  computed: {},
  components: {
    forms
  }
};
</script>
 <style lang="scss" scoped>
.addNewZs {
  min-height: calc(100vh - 56px);
  background-color: $white;
  position: relative;
  z-index: 1;
  .save {
    background-image: $gradualbule;
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: $white;
    letter-spacing: 0;
    text-align: center;
    height: 52px;
    line-height: 52px;
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
  }
  .pickExpert {
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    background-color: $white;
    .pickHead {
      height: 44px;
      line-height: 44px;
      text-align: center;
      .cancel,
      .confirm {
        height: 100%;
        padding: 0 16px;
        font-size: 14px;
        background-color: $transparent;
        border: none;
        cursor: pointer;
      }
      .cancel {
        color: $grey969799;
        float: left;
      }
      .confirm {
        color: $grey576b95;
        float: right;
      }
      .title {
        max-width: 50%;
        font-weight: 500;
        font-size: 16px;
        line-height: 20px;
        text-align: center;
      }
    }
    .expertBody {
      height: 132px;
      overflow: scroll;
      padding: 0 16px;
      li {
        width: 100%;
        height: 44px;
        line-height: 44px;
        border-bottom: 1px solid $greyee;
        .choose {
          float: right;
          color: $green;
        }
      }
    }
  }
  .van-picker {
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 0;
  }
}
</style>
